import PropTypes from "prop-types";
import React from "react";
import ImageLoader from "react-imageloader";
import Placeholder from "../../../pois/components/placeholder";

function ListItemImage({ image, title }) {
  const renderPlaceholder = () => (
    <Placeholder
      title={title}
      fontSize={50}
      aspectRatio={5 / 4}
    />
  );

  return (
    <ImageLoader
      src={image.path}
      preloader={() => renderPlaceholder(title)}
    >
      {renderPlaceholder(title)}
    </ImageLoader>
  );
}

ListItemImage.propTypes = {
  /**
   * The name of the POI
   * key: name
   */
  title: PropTypes.string.isRequired,
  /**
   * Image src for the POI; required keys are path and orientation
   * partner-activities key: links.image
   */
  image: PropTypes.object,
};

export default ListItemImage;


// WEBPACK FOOTER //
// ./assets/shared/components/listItemImage/index.jsx